/**
 * Attendees.js — Checkout attendee-details step.
 *
 * Renders a form for every cart line item so the buyer can supply attendee
 * information (name, email, mobile, dietary requirements, etc.) before
 * proceeding to payment. Validates required fields, associates the Shopify
 * buyer identity to the cart via GraphQL, then POSTs the collected data to
 * the engine API (post-order-data-new.php) before redirecting to Shopify
 * Checkout.
 *
 * Props:
 *  - EngineURL {string}              Base URL for the engine REST API.
 *  - UserData {object}               Logged-in Shopify customer object.
 *  - useLoggedIn {boolean}           Whether the user is authenticated.
 *  - setAddresstoCheckout {Function} Triggers address association on mount.
 *  - ShowLoginPopup {Function}       Opens the login modal.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, {useState, useEffect} from "react";
import {Container, Row, Col, Form, Card, Button, Accordion, AccordionButton, Alert} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import {useMutation} from "@apollo/react-hooks";
import {Helmet} from "react-helmet";

// ─── Internal components ──────────────────────────────────────────────────────
import {PrivacyPolicy} from "../Modals/PrivacyPolicy";
import {TermsCondition} from "../Modals/TermsCondition";

// ─── Phone input ──────────────────────────────────────────────────────────────
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

// ─── Icons ────────────────────────────────────────────────────────────────────
import {UserIcon, CallPhoneIcon, LoaderIcon, InformationIcon} from "../../icons";
import QuantitySelect from "../common/QuantitySelect";

// ─── GraphQL ──────────────────────────────────────────────────────────────────
import {cartBuyerIdentityUpdate} from "../grappql/Checkout/mutation/cartBuyerIdentityUpdate";

export const Attendees = (props) => {
  const location = useLocation();
  const queryParam = queryString.parse(location.search);
  const GAurl = queryParam["gclid"] !== undefined ? "?gclid=" + queryParam["gclid"] : "";

  const [isITloading, setisITloading] = useState(false);
  const [finalData, setfinalData] = useState();
  const [CurrentuserDetail, setCurrentuserDetail] = useState(undefined);
  const [IsThereAnyPastPrograme, setIsThereAnyPastPrograme] = useState(false);
  const [shopifyCustomerData, setShopifyCustomerData] = useState(null);


  useEffect(() => {
    props.setAddresstoCheckout();
    localStorage.setItem("was_book", false);
  }, []);

  const [CartData, setCheckout] = useState(() => {
    const cart_item = localStorage.getItem("checkout_id");
    return cart_item !== null ? JSON.parse(cart_item) : undefined;
  });

  const [CardItem_sku, AdditemTOcart_sku] = useState(() => {
    const cart_item = localStorage.getItem("cart_session_sku");
    return cart_item !== null ? JSON.parse(cart_item) : {lines: []};
  });

  /***
   * Associative  Customer to checkout
   */
  const [
    Associate_Customer_to_Checkout,
    {
      loading: Associate_Customer_to_Checkout_loading,
      data: Associate_Customer_to_Checkout_loading_data,
      error: Associate_Customer_to_Checkout_loading_error,
    },
  ] = useMutation(cartBuyerIdentityUpdate);

  /***
   * After assign user to Order
   * Need to assign address
   */
  const [UpdateloginUserDetail, setUpdateloginUserDetail] = useState(() => {
    const localdetail = localStorage.getItem("userDetail");
    return localdetail !== null ? JSON.parse(localdetail) : undefined;
  });

  const customerAccessToken = UpdateloginUserDetail != undefined ? UpdateloginUserDetail.accessToken : undefined;

  /** Returns true if the given string is a valid e-mail address. */
  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  /*  useEffect(() => {
        // console.log(props.useLoggedIn)
        if (UserData != undefined && props.useLoggedIn) {

            if (CartData != undefined && props.customerAccessToken != undefined && CartData != undefined) {
                Associate_Customer_to_Checkout({
                    variables: {
                        checkoutId: CartData.cart.id,
                        buyerIdentityInput:{
                            //customerAccessToken: props.customerAccessToken,
                            email: UserData.customer.email,
                            phone: UserData.customer.phone,
                        }
                    }
                })

            }

            // console.log(UserData);

            if (CartData != undefined && props.customerAccessToken != undefined && UserData != undefined && UserData.customer != null && UserData.customer.addresses.edges.length) {
                //  console.log('associate address');
                const used_address_detail = {
                    address1: props.UserData.addresses.edges[0].node.address1,
                    city: props.UserData.addresses.edges[0].node.city,
                    country: props.UserData.addresses.edges[0].node.country,
                    firstName: props.UserData.addresses.edges[0].node.firstName !== "" ? props.UserData.addresses.edges[0].node.firstName : UserData.customer.firstName,
                    lastName: props.UserData.addresses.edges[0].node.lastName !== "" ? props.UserData.addresses.edges[0].node.lastName : UserData.customer.lastName,
                    phone: props.UserData.addresses.edges[0].node.phone !== "" ? props.UserData.addresses.edges[0].node.phone : UserData.customer.phone,
                    province: props.UserData.addresses.edges[0].node.province,
                    zip: props.UserData.addresses.edges[0].node.zip

                };

  
            }
        }

    }, [UserData]);*/

  useEffect(() => {
    if (props.UserData != undefined) {
      //   console.log('UserData');
      // console.log(props.UserData);

      const save_data = {
        email: props.UserData.email,
        first_name: props.UserData.firstName,
        last_name: props.UserData.lastName,
        mobile: props.UserData.phone,
        company: "",
      };
     // console.log(save_data);
      setCurrentuserDetail(save_data);
      try {
        const api_URL2 = props.EngineURL + "create-account/get_customer.php";
        const formData = new URLSearchParams();
        const user_token = props.UserData.accessToken; // Replace `yourToken` with your actual token variable
        formData.append("contact_id", props.UserData.email);

         axios
          .post(api_URL2, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${user_token}`, // Replace `yourToken` with your actual token variable
            },
          })
          .then((response2) => {
            console.log('response2',response2);
            /***
             * Assign data to State
             */
        
            if ((response2.status === 200) & (response2.data.code === 200)) {
                    console.log(response2);
              setShopifyCustomerData(response2.data.data);

              if (CartData !== undefined) {
                Associate_Customer_to_Checkout({
                  variables: {
                    checkoutId: CartData.cart.id,
                    buyerIdentityInput: {
                      email: response2.data.data.email,
                      phone: response2.data.data.phone,
                      // firstName: response2.data.data.firstName,
                      // lastName: response2.data.data.lastName,
                    },
                  },
                });
              }
            } else {
              // console.log(response1.data.error);
            }
          })
          .catch((error) => {
            console.error("Error fetching customer data:", error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }, [props.UserData]);

  let temp = [];
  if (CartData != undefined) {
    CartData.cart.lines.edges.map((cartItem) => {
      let innertemp = [];
      [...Array(cartItem.node.quantity)].map((x, i) => {
        innertemp.push({
          booking_for_self: false,
          company: "",
          medicare_provider_no: "",
          email: "",
          email_error: false,
          salutation: "",
          first_name: "",
          first_name_error: false,
          last_name: "",
          last_name_error: false,
          mobile_number: "",
          mobile_number_error: false,
          landline: "",
          mobile_number_country_code: "+61",
          landline_country_code: "+61",
          mobile_number_without_country_code: "",
          landline_without_country_code: "",
          dietary: [],
          is_book: isBook(cartItem.node.merchandise.id),
        });
      });
      var test = cartItem.node.id;
      temp.push({[test]: innertemp});
    });
  }
  const [AttendeesField, setAttendeesDetail] = useState(temp);

  /** Controls how many attendee forms are shown per cart line (driven by the quantity selector). */
  const [displayQty, setDisplayQty] = useState(() =>
    CartData != null ? CartData.cart.lines.edges.map((item) => item.node.quantity) : []
  );

  const [ValidationError, setValidationError] = useState(false);
  const [PiravacySelected, setPiravacySelected] = useState(false);
  const [TermSelected, setTermSelected] = useState(false);
  const [PiravacySelected_error, setPiravacySelected_error] = useState(false);
  const [TermSelected_error, setTermSelected_error] = useState(false);
  const [ErrorMessageText, setErrorMessageText] = useState(undefined);

  const [Is_intensive_download, set_Is_intensive_download] = useState(false);

  const [tc_show, set_tc_show] = useState(false);
  const [pp_show, set_pp_show] = useState(false);

  const HideTCPopup = () => set_tc_show(false);
  const HidePPPopup = () => set_pp_show(false);

  const [formUpdated, setformUpdated] = useState(false);

  const [CheckoutDataHaveIssue, setCheckoutDataHaveIssue] = useState(false);

  /** Returns true if the program start date-time has already passed. */
  const program_date_is_gone_or_not = (program_start_date_time) => {
    if (program_start_date_time === null || program_start_date_time === "") {
      return false;
    }
    program_start_date_time = new Date(program_start_date_time);
    let program_time_modify = program_start_date_time.setHours(program_start_date_time.getHours());
    let current_time = new Date().getTime();
    if (parseFloat(program_time_modify) - parseFloat(current_time) > 0) {
      return false;
    } else {
      return true;
    }
  };

  /***
   * Something is not correct with data
   */

  useEffect(() => {
    if (CheckoutDataHaveIssue) {
      alert("Something went wrong. Please try again");
      localStorage.removeItem("checkout_id");
      localStorage.removeItem("cart_session");
      localStorage.removeItem("cart_session_sku");
      window.location.reload();
    }
  }, [CheckoutDataHaveIssue]);

  /**
   * Returns the SKU code for a cart variant.
   * @param {string} merchandiseId - Shopify variant GID.
   * @returns {string|undefined} SKU string, or undefined (triggers data-issue flag).
   */
  function getSKU(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.sku;
      }
    });
    if (psku === undefined) {
      if (!CheckoutDataHaveIssue) {
        setCheckoutDataHaveIssue(true);
      }
    }
    return psku;
  }

  /**
   * Returns the product slug (handle) for a cart variant.
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function getHandle(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.slug;
      }
    });
    return psku;
  }

  /**
   * Get stream type
   * @param {*} merchandiseId
   * @returns stream type
   */
  function getStream(merchandiseId) {
    let psku = "";
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.stream_type;
      }
    });
    return psku;
  }

  /** Returns true if value is not null, undefined, or empty string. */
  const isNotEmpty = (value) => {
    return value !== null && value !== undefined && value !== "";
  };

  /**
   * Returns the Salesforce record type (e.g. "Book") for a cart variant.
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function getRecordType(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.record_type;
      }
    });
    return psku;
  }

  /** Returns true if the program date for this variant has already passed. */
  function IndividualDateisonOver(merchandiseId) {
    let psku = false;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = program_date_is_gone_or_not(linedata.start_date);
      }
    });
    return psku;
  }

  /**
   * Returns the tags array for a cart variant (used for book/intensive detection).
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function getTags(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.tags;
      }
    });
    return psku;
  }

  /**
   * Returns the program structure string (e.g. "Medicare Billing Course") for a variant.
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function getProgram_structure(merchandiseId) {
    let program_structure = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId === merchandiseId) {
        program_structure = linedata.program_structure;
      }
    });
    return program_structure;
  }
  /**
   * Returns the product slug for a cart variant (used for thank-you page links).
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function getSlug(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.slug;
      }
    });
    return psku;
  }

  /**
   * Returns true if the variant is tagged as a "book" (skips attendee form).
   * @param {string} merchandiseId - Shopify variant GID.
   */
  function isBook(merchandiseId) {
    let check_book = false;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        let taglist = linedata.tags;
        if (taglist.includes("book")) {
          check_book = true;
        }
      }
    });
    return check_book;
  }

  /**
   * Returns the first product image URL for a cart variant.
   * @param {string} merchandiseId - Shopify variant GID.
   * @returns {string|undefined} Image URL, or undefined (triggers data-issue flag).
   */
  function getProgramStructureImage(merchandiseId) {
    let psku = undefined;
    CardItem_sku.lines.map(function (linedata) {
      if (linedata.merchandiseId == merchandiseId) {
        psku = linedata.pimage[0];
      }
    });
    if (psku === undefined) {
      if (!CheckoutDataHaveIssue) {
        // console.log("pskupsku ->" + psku)
        setCheckoutDataHaveIssue(true);
      }
    }
    return psku;
  }

  /**
   * Extracts the Shopify checkout token from the cart's checkoutUrl.
   * Strips the Shopify domain prefix and the ?key= query suffix.
   */
  function getToken() {
    var weburl = CartData.cart.checkoutUrl;
    var n = weburl.lastIndexOf("/");
    var removekey = weburl.substring(n + 1);
    return removekey.split("?key=")[0];
  }

  /***
   * Check product list have any product that are releated to "internsive download"
   */
  useEffect(() => {
    if (CartData != undefined) {
      set_Is_intensive_download(false);
      let psku = undefined;
      var variant_ID_list = [];
      CartData.cart.lines.edges.map((cartItem, i) => {
        variant_ID_list.push(cartItem.node.merchandise.id);
      });

      CardItem_sku.lines.map(function (linedata) {
        if (variant_ID_list.includes(linedata.merchandiseId)) {
          let taglist = linedata.tags;
          if (taglist.includes("online-intensive-(to-download)")) {
            set_Is_intensive_download(true);
          }

          if (program_date_is_gone_or_not(linedata.start_date)) {
            setIsThereAnyPastPrograme(true);
          }
        }
      });
    }
  }, [CartData]);

  /**
   * Form submit handler. Validates all attendee fields and T&C/privacy checkboxes,
   * builds the finalData payload, saves thank-you metadata to localStorage,
   * then calls SenddataTOsalesforce.
   * @param {React.SyntheticEvent} e - Form submit event.
   */
  const SubmitAttendees = (e) => {
    // console.log(AttendeesField);

    e.preventDefault();
    setformUpdated(true);
    localStorage.setItem("checkout_token", getToken());
    var finalData = {
      checkout_token: getToken(),
      checkout: {
        id: CartData.cart.id,
      },
      lineItems: {
        edges: [],
      },
    };

    var go_ahead = true;
    setTermSelected_error(false);
    setPiravacySelected_error(false);
    setValidationError(false);
    setErrorMessageText(undefined);

    CartData.cart.lines.edges.map((cartItem, i) => {
      AttendeesField[i][cartItem.node.id].map((dt) => {
        dt.email_error = false;
        dt.first_name_error = false;
        dt.last_name_error = false;
        dt.mobile_number_error = false;
        if (dt.is_book === false) {
          if (dt.email == "") {
            go_ahead = false;
            dt.email_error = true;
          }
          if (dt.email !== "" && !validateEmail(dt.email)) {
            go_ahead = false;
            dt.email_error = true;
          }
          if (dt.first_name == "") {
            go_ahead = false;
            dt.first_name_error = true;
          }
          if (dt.last_name == "") {
            go_ahead = false;
            dt.last_name_error = true;
          }
          if (dt.mobile_number == "") {
            go_ahead = false;
            dt.mobile_number_error = true;
          }
        } else {
          localStorage.setItem("was_book", true);
        }
      });
    });
    //console.log(AttendeesField);
    setformUpdated(false);

    if (!TermSelected) {
      go_ahead = false;
      setTermSelected_error(true);
    }

    if (!PiravacySelected) {
      go_ahead = false;
      setPiravacySelected_error(true);
    }

    if (go_ahead) {
      CartData.cart.lines.edges.map((cartItem, i) => {
        var temp = {
          id: cartItem.node.id,
          quantity: cartItem.node.quantity,
          title: cartItem.node.merchandise.product.title,
          sku: getSKU(cartItem.node.merchandise.id),
          handle: getHandle(cartItem.node.merchandise.id),
          stream_type: getStream(cartItem.node.merchandise.id),
          is_live_stream: getStream(cartItem.node.merchandise.id).toLowerCase() == "live stream" ? true : false,
          is_face_to_face: getStream(cartItem.node.merchandise.id).toLowerCase() == "face to face" ? true : false,
          is_book: isBook(cartItem.node.merchandise.id),
          attendees: AttendeesField[i][cartItem.node.id],
        };
        finalData.lineItems.edges.push(temp);
      });

      var thank_you_paeg_program_structure = [];
      CartData.cart.lines.edges.map((cartItem, i) => {
        // Program type (e.g. "Pre-Recorded Webcasts") — the "Program type"
        // shown on the product page. Pulled from the product's 'all_data'
        // metafield (arena/all_data) so it can be shown on the thank-you page,
        // which has no Salesforce/program lookup of its own.
        let programType = "";
        const product = cartItem.node.merchandise.product;
        const metafields = (product && product.metafields) || [];
        metafields.forEach((m) => {
          if (m && m.key === "all_data" && m.value) {
            try {
              const pt = JSON.parse(m.value).Program_Types__c;
              programType = Array.isArray(pt) ? pt.join(", ") : (pt || "");
            } catch (e) { /* leave blank on parse failure */ }
          }
        });
        var temp = {
          title: product.title,
          tag: getTags(cartItem.node.merchandise.id),
          slug: getSlug(cartItem.node.merchandise.id),
          type: programType,
        };
        thank_you_paeg_program_structure.push(temp);
      });

      localStorage.setItem("thank_you_image", JSON.stringify(thank_you_paeg_program_structure));

      setfinalData(finalData);
      //console.log(finalData);
      SenddataTOsalesforce(finalData);
    } else {
      setValidationError(true);
      // No general "Fields are required!" banner — each field (and the terms /
      // privacy checkboxes) shows its own inline validation message.
    }
  };

  /**
   * POSTs the assembled attendee payload to the engine API, then redirects
   * to the Shopify checkout URL on success. Reloads the page on failure.
   * @param {object} finalData - Attendee + checkout payload built by SubmitAttendees.
   */
  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop()) : '';
  }

  function SenddataTOsalesforce(finalData) {
    window.scrollTo(0, 0);

    setisITloading(true);

    // ── Attach saved tracking cookies, if present ──────────────
    const trackingFields = {
      tracking_link: getCookie('leo_tracking_link'),
      utm_campaign: getCookie('leo_utm_campaign'),
      utm_content: getCookie('leo_utm_content'),
      utm_medium: getCookie('leo_utm_medium'),
      utm_source: getCookie('leo_utm_source'),
      utm_term: getCookie('leo_utm_term'),
      gclid: getCookie('leo_gclid'),
      fbclid: getCookie('leo_fbclid'),
      msclkid: getCookie('leo_msclkid'),
    };
    
    // Only include fields that actually have a value
    Object.keys(trackingFields).forEach(function (key) {
      if (!trackingFields[key]) delete trackingFields[key];
    });

    const finalDataWithTracking = {
      ...finalData,
      ...trackingFields,
    };
    axios
      .post(props.EngineURL + "chk/post-order-data-new.php", finalDataWithTracking)
      .then(function (response) {
        //console.log(response);
        if (response.status === 200) {
          if (response.data.length !== 0) {
            if (response.data.status !== "failed") {
              setTimeout(function () {
                const baseUrl = CartData.cart.checkoutUrl
                    .replace("https://demo-leo.myshopify.com/", "https://checkout.leocussen.edu.au/");

                // ── Billing address prefill ───────────────────
                const customer = shopifyCustomerData;

                const prefillParams = [
                    `checkout[email]=${encodeURIComponent(customer?.email ?? '')}`,
                    `checkout[billing_address][first_name]=${encodeURIComponent(customer?.firstName ?? '')}`,
                    `checkout[billing_address][last_name]=${encodeURIComponent(customer?.lastName ?? '')}`,
                    `checkout[billing_address][phone]=${encodeURIComponent(customer?.phone ?? '')}`,
                ].join('&');

                // baseUrl already has ?key=xxx so use &
                window.location.href = `${baseUrl}&${prefillParams}`;
            }, 500);
            } else {
              alert(response.data.message);
              window.location.reload();
              setisITloading(false);
            }
          }
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  }

  //  console.log(CurrentuserDetail);

  /**
   * Updates a specific attendee field in AttendeesField state.
   * When "booking for myself" is toggled on, auto-fills from CurrentuserDetail.
   * When toggled off, clears the affected fields via DOM getElementById.
   * @param {string} node_id       - Cart line item node ID.
   * @param {number} index         - Attendee index within the line item.
   * @param {React.SyntheticEvent} event - Change event from the form field.
   * @param {number} mainindex     - Cart line index in CartData.cart.lines.edges.
   * @param {string} merchandiseId - Shopify variant GID.
   */
  const handleInputChange = (node_id, index, event, mainindex, merchandiseId) => {
    const newarray = AttendeesField;
    var field_id = mainindex + node_id + index;
    if (event.target.name === "my_self" && event.target.value == "true" && event.target.checked) {
      newarray[mainindex][node_id][index].booking_for_self = event.target.value;

      if (CurrentuserDetail != undefined) {
        newarray[mainindex][node_id][index].email = CurrentuserDetail.email;
        document.getElementById(field_id + "email").value = CurrentuserDetail.email;

        newarray[mainindex][node_id][index].first_name = CurrentuserDetail.first_name;
        document.getElementById(field_id + "first_name").value = CurrentuserDetail.first_name;

        newarray[mainindex][node_id][index].last_name = CurrentuserDetail.last_name;
        document.getElementById(field_id + "last_name").value = CurrentuserDetail.last_name;

        newarray[mainindex][node_id][index].mobile_number = CurrentuserDetail.mobile;

        newarray[mainindex][node_id][index].mobile_number_without_country_code = CurrentuserDetail.mobile.substring(3);
        document.getElementById(field_id + "mobile_number_without_country_code").value = CurrentuserDetail.mobile.substring(3);

        newarray[mainindex][node_id][index].mobile_number_country_code = CurrentuserDetail.mobile.substring(0, 3);
        document.getElementById(field_id + "mobile_number_country_code").value = CurrentuserDetail.mobile.substring(0, 3);

        newarray[mainindex][node_id][index].company = CurrentuserDetail.company;
        document.getElementById(field_id + "company").value = CurrentuserDetail.company;
      }

      //   console.log(CurrentuserDetail);
    } else {
      if (event.target.name === "my_self") {
        newarray[mainindex][node_id][index].booking_for_self = event.target.value;

        newarray[mainindex][node_id][index].email = null;
        document.getElementById(field_id + "email").value = null;

        newarray[mainindex][node_id][index].first_name = null;
        document.getElementById(field_id + "first_name").value = null;

        newarray[mainindex][node_id][index].last_name = null;
        document.getElementById(field_id + "last_name").value = null;

        newarray[mainindex][node_id][index].company = null;
        document.getElementById(field_id + "company").value = null;

        newarray[mainindex][node_id][index].mobile_number_without_country_code = null;
        newarray[mainindex][node_id][index].mobile_number = null;
        newarray[mainindex][node_id][index].mobile_number_country_code = null;
        document.getElementById(field_id + "mobile_number_without_country_code").value = null;
        document.getElementById(field_id + "mobile_number_country_code").value = null;
      } else if (event.target.name === "email") {
        newarray[mainindex][node_id][index].email = event.target.value;
        newarray[mainindex][node_id][index].email_error = false;
      } else if (event.target.name === "company") {
        newarray[mainindex][node_id][index].company = event.target.value;
      } else if (event.target.name === "medicare_provider_no") {
        newarray[mainindex][node_id][index].medicare_provider_no = event.target.value;
      } else if (event.target.name === "salutation") {
        newarray[mainindex][node_id][index].salutation = event.target.value;
      } else if (event.target.name === "first_name") {
        newarray[mainindex][node_id][index].first_name = event.target.value;
        newarray[mainindex][node_id][index].first_name_error = false;
      } else if (event.target.name === "last_name") {
        newarray[mainindex][node_id][index].last_name = event.target.value;
        newarray[mainindex][node_id][index].last_name_error = false;
      } else if (event.target.name === "mobile_number_without_country_code") {
        newarray[mainindex][node_id][index].mobile_number_without_country_code = event.target.value;
        newarray[mainindex][node_id][index].mobile_number =
          document.getElementById(field_id + "mobile_number_country_code").value +
          "" +
          document.getElementById(field_id + "mobile_number_without_country_code").value;
        newarray[mainindex][node_id][index].mobile_number_error = false;
      } else if (event.target.name === "mobile_number_country_code") {
        newarray[mainindex][node_id][index].mobile_number_country_code = event.target.value;
        newarray[mainindex][node_id][index].mobile_number =
          document.getElementById(field_id + "mobile_number_country_code").value +
          "" +
          document.getElementById(field_id + "mobile_number_without_country_code").value;
        newarray[mainindex][node_id][index].mobile_number_error = false;
      } else if (event.target.name === "landline_country_code") {
        newarray[mainindex][node_id][index].landline_country_code = event.target.value;
        newarray[mainindex][node_id][index].landline =
          document.getElementById(field_id + "landline_country_code").value +
          "" +
          document.getElementById(field_id + "landline_without_country_code").value;
      } else if (event.target.name === "landline_without_country_code") {
        newarray[mainindex][node_id][index].landline_without_country_code = event.target.value;
        newarray[mainindex][node_id][index].landline =
          document.getElementById(field_id + "landline_country_code").value +
          "" +
          document.getElementById(field_id + "landline_without_country_code").value;
      } else if (event.target.name === "dietary") {
        newarray[mainindex][node_id][index].dietary.push(event.target.value);
      }
    }

    setAttendeesDetail([...newarray]); //console.log(AttendeesField);
  };

  /** Formats a number to 2 decimal places with thousands-separator commas. */
  const numberWithCommas = (x) => {
    return parseFloat(x)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (isITloading) {
    return (
      <div className="pre_loader">
        <LoaderIcon />
      </div>
    );
  }
  if (CartData != undefined) {
    return (
      <div className="attendees_page" data-test={formUpdated}>
        <Helmet>
          <title>Attendees | Leo Cussen Centre for Law</title>
          <meta name="description" content="" />
        </Helmet>
        <Container>
          <Row>
            <Col md={8} xs={12}>
              <div className="attendees_content">
                <h1 className="mb-0">Delivery Option</h1>
                <h5 className="display-5 text-secondary">Event Attendance</h5>
                {props.useLoggedIn ? (
                  ""
                ) : (
                  <div className="information_block card border-exlight attendy-paragraph" key="tt">
                    <div className="information_content ">
                      <InformationIcon />
                      {Is_intensive_download ? (
                        <p className="small small-dec mb-0">
                          Login is required, click<a onClick={(e) => props.ShowLoginPopup()} className="login_link_inline"> here</a> to login to your account
                        </p>
                      ) : (
                        <p className="small small-dec mb-0">
                          If you are already registered with Leo Cussen, click<a onClick={(e) => props.ShowLoginPopup()} className="login_link_inline"> here</a> to login to your
                          account
                        </p>
                      )}
                    </div>
                  </div>
                )}

                <div className="cpd_attendees">
                  {CartData.cart.lines.edges.map((cartItem, mainindex) => {
                    const tst = mainindex + 200;
                    // console.log(cartItem);
                    return (
                      <Accordion defaultActiveKey={tst} key={"lol" + mainindex}>
                        <Accordion.Item eventKey={tst} key={tst} className="shadow bg-white rounded-2 border-0 attendees_card">
                          <Card className={getRecordType(cartItem.node.merchandise.id) == "Book" ? "no-need-atendee border-0" : "border-0"}>
                            <AccordionButton id={"toogle" + tst}></AccordionButton>{" "}
                            <Card.Body>
                              <div className="program_cate2 d-none d-md-flex justify-content-center flex-column">
                                <img src={getProgramStructureImage(cartItem.node.merchandise.id)} alt={cartItem.node.merchandise.product.title} />
                              </div>
                              <Card.Title className="d-flex flex-wrap align-items-center">
                                <h3
                                  onClick={() => {
                                    document.getElementById(`toogle${tst}`).click();
                                  }}
                                >
                                  {cartItem.node.merchandise.product.title}
                                </h3>
                                <div
                                  className="attendees_details_right d-flex align-items-center justify-content-end"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <QuantitySelect
                                    className="attendees_total"
                                    value={displayQty[mainindex]}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(newQty) => {
                                      const node_id = cartItem.node.id;

                                      // 1) Update the visible count
                                      const updatedQty = [...displayQty];
                                      updatedQty[mainindex] = newQty;
                                      setDisplayQty(updatedQty);

                                      // 2) Grow / shrink the attendee field slots to match
                                      const newarray = AttendeesField.map((a) => ({...a}));
                                      const slots = newarray[mainindex][node_id];
                                      const currentLen = slots.length;
                                      if (newQty > currentLen) {
                                        for (let idx = currentLen; idx < newQty; idx++) {
                                          slots.push({
                                            booking_for_self: false,
                                            company: "",
                                            medicare_provider_no: "",
                                            email: "",
                                            email_error: false,
                                            salutation: "",
                                            first_name: "",
                                            first_name_error: false,
                                            last_name: "",
                                            last_name_error: false,
                                            mobile_number: "",
                                            mobile_number_error: false,
                                            landline: "",
                                            mobile_number_country_code: "+61",
                                            landline_country_code: "+61",
                                            mobile_number_without_country_code: "",
                                            landline_without_country_code: "",
                                            dietary: [],
                                            is_book: isBook(cartItem.node.merchandise.id),
                                          });
                                        }
                                      } else if (newQty < currentLen) {
                                        newarray[mainindex][node_id] = slots.slice(0, newQty);
                                      }
                                      setAttendeesDetail([...newarray]);

                                      // 3) Optimistically reflect the new qty in this page's
                                      //    order summary (no reload), then sync the cart + Shopify.
                                      setCheckout((prev) => {
                                        if (prev == undefined) return prev;
                                        const next = JSON.parse(JSON.stringify(prev));
                                        let subtotal = 0;
                                        next.cart.lines.edges.forEach((edge) => {
                                          if (edge.node.id === node_id) edge.node.quantity = newQty;
                                          const unit = parseFloat(edge.node.merchandise.price.amount) || 0;
                                          subtotal += unit * edge.node.quantity;
                                          if (edge.node.cost && edge.node.cost.totalAmount) {
                                            edge.node.cost.totalAmount.amount = (unit * edge.node.quantity).toFixed(2);
                                          }
                                        });
                                        if (next.cart.cost) {
                                          if (next.cart.cost.subtotalAmount) next.cart.cost.subtotalAmount.amount = subtotal.toFixed(2);
                                          if (next.cart.cost.totalAmount) next.cart.cost.totalAmount.amount = subtotal.toFixed(2);
                                        }
                                        return next;
                                      });

                                      // 4) Single source of truth → global cart + backend
                                      if (props.UpdateCartItem) props.UpdateCartItem(newQty, node_id);
                                    }}
                                  />
                                  <h3 className="attendees_amount">
                                    ${numberWithCommas(cartItem.node.merchandise.price.amount * cartItem.node.quantity)}
                                  </h3>
                                </div>
                                {IndividualDateisonOver(cartItem.node.merchandise.id) ? (
                                  <Alert variant="danger">This Program has been over. Kindly please remove it from cart</Alert>
                                ) : null}
                              </Card.Title>
                              <Accordion.Body className="p-0">
                                {[...Array(displayQty[mainindex])].map((x, i) => {
                                  const tetst_index = i;
                                  const total_attnds = i + 1;
                                  const node_id = cartItem.node.id;
                                  return (
                                    <Card.Text
                                      key={i}
                                      as="div"
                                      className={
                                        getRecordType(cartItem.node.merchandise.id) == "Book"
                                          ? "d-none attendees_details_block"
                                          : "attendees_details_block"
                                      }
                                    >
                                      <h6 className="display-6">Attendee Details {total_attnds}</h6>
                                      <Form>
                                        <div className="attendees_details_users d-flex flex-wrap align-items-center">
                                          <UserIcon />
                                          <small>{total_attnds}</small>
                                          <Form.Group className={total_attnds == 1 ? "my_self_holder" : "d-none"} controlId={tst + "CheckboxBooking"}>
                                            <Form.Check
                                              name="my_self"
                                              type="checkbox"
                                              value="true"
                                              label="I am booking for myself."
                                              htmlFor={tst + "CheckboxBooking"}
                                              onChange={(event) =>
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id)
                                              }
                                              required
                                            />
                                          </Form.Group>
                                          {props.useLoggedIn ? (
                                            ""
                                          ) : (
                                            <>
                                              <p className="address small mygrey-text mb-0">
                                                Click<a onClick={(e) => props.ShowLoginPopup()} className="login_link_inline"> here</a> to login to your account.
                                              </p>
                                            </>
                                          )}
                                        </div>
                                        <div className="attendees_form_details">
                                          <Form.Group className="form-group" data-mainindex={formUpdated}>
                                            <Form.Label>Attendee Email<span className="lc-required">*</span></Form.Label>
                                            <Form.Control
                                              type="email"
                                              className={
                                                AttendeesField[mainindex][node_id][tetst_index].email_error != undefined &&
                                                AttendeesField[mainindex][node_id][tetst_index].email_error === true
                                                  ? "form-error"
                                                  : ""
                                              }
                                              name="email"
                                              id={mainindex + node_id + tetst_index + "email"}
                                              placeholder="Attendee Email"
                                              onChange={(event) => {
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id);
                                                setformUpdated("dfsd");
                                              }}
                                            />
                                            {AttendeesField[mainindex][node_id][tetst_index].email_error === true && (
                                              <span className="field-error-msg">Please enter a valid email address</span>
                                            )}
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>Salutation</Form.Label>
                                            <Form.Select
                                              name="salutation"
                                              className="form-control"
                                              onChange={(event) =>
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id)
                                              }
                                            >
                                              <option value="">Please select</option>
                                              <option value="Mr.">Mr.</option>
                                              <option value="Mrs.">Mrs.</option>
                                              <option value="Ms.">Ms.</option>
                                              <option value="Miss">Miss</option>
                                              <option value="Dr.">Dr.</option>
                                              <option value="Prof.">Prof.</option>
                                              <option value="Other">Other</option>
                                            </Form.Select>
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>First Name<span className="lc-required">*</span></Form.Label>
                                            <Form.Control
                                              className={
                                                AttendeesField[mainindex][node_id][tetst_index].first_name_error
                                                  ? "form-group form-error"
                                                  : "form-group"
                                              }
                                              type="text"
                                              id={mainindex + node_id + tetst_index + "first_name"}
                                              name="first_name"
                                              placeholder="First Name"
                                              onChange={(event) => {
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id);
                                                setformUpdated("dfsdd");
                                              }}
                                            />
                                            {AttendeesField[mainindex][node_id][tetst_index].first_name_error && (
                                              <span className="field-error-msg">First name is required</span>
                                            )}
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>Last Name<span className="lc-required">*</span></Form.Label>
                                            <Form.Control
                                              type="text"
                                              className={
                                                AttendeesField[mainindex][node_id][tetst_index].last_name_error
                                                  ? "form-group form-error"
                                                  : "form-group"
                                              }
                                              id={mainindex + node_id + tetst_index + "last_name"}
                                              placeholder="Last Name"
                                              name="last_name"
                                              onChange={(event) => {
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id);
                                                setformUpdated("dfsd");
                                              }}
                                            />
                                            {AttendeesField[mainindex][node_id][tetst_index].last_name_error && (
                                              <span className="field-error-msg">Last name is required</span>
                                            )}
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>Organisation</Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Organisation"
                                              name="company"
                                              id={mainindex + node_id + tetst_index + "company"}
                                              onChange={(event) =>
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id)
                                              }
                                            />
                                          </Form.Group>
                                          <Form.Group
                                            className={
                                              getProgram_structure(cartItem.node.merchandise.id) === "Medicare Billing Course"
                                                ? "form-group"
                                                : "form-group  d-none"
                                            }
                                          >
                                            <Form.Control
                                              type="text"
                                              placeholder="Medicare Provider No"
                                              name="medicare_provider_no"
                                              id={mainindex + node_id + tetst_index + "medicare_provider_no"}
                                              maxLength="8"
                                              pattern="[A-Za-z0-9]{1,8}"
                                              onChange={(event) =>
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id)
                                              }
                                            />
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>Mobile Number<span className="lc-required">*</span></Form.Label>
                                            <PhoneInput
                                              international
                                              defaultCountry="AU"
                                              placeholder="0412 345 678"
                                              className={AttendeesField[mainindex][node_id][tetst_index].mobile_number_error ? "form-error" : ""}
                                              value={AttendeesField[mainindex][node_id][tetst_index].mobile_number || ""}
                                              onChange={(value) => {
                                                const newarray = AttendeesField;
                                                newarray[mainindex][node_id][tetst_index].mobile_number = value || "";
                                                newarray[mainindex][node_id][tetst_index].mobile_number_without_country_code = value || "";
                                                newarray[mainindex][node_id][tetst_index].mobile_number_error = false;
                                                setAttendeesDetail([...newarray]);
                                                setformUpdated("dfsdss");
                                              }}
                                            />
                                            {/* Hidden inputs preserve element IDs used by "booking for myself" auto-fill */}
                                            <input type="hidden" id={mainindex + node_id + tetst_index + "mobile_number_without_country_code"} />
                                            <input type="hidden" id={mainindex + node_id + tetst_index + "mobile_number_country_code"} defaultValue="+61" />
                                            {AttendeesField[mainindex][node_id][tetst_index].mobile_number_error && (
                                              <span className="field-error-msg">Please enter a valid mobile number</span>
                                            )}
                                          </Form.Group>
                                          <Form.Group className="form-group">
                                            <Form.Label>Phone Number</Form.Label>
                                            <PhoneInput
                                              international
                                              defaultCountry="AU"
                                              placeholder="0412 345 678"
                                              value={AttendeesField[mainindex][node_id][tetst_index].landline || ""}
                                              onChange={(value) => {
                                                const newarray = AttendeesField;
                                                newarray[mainindex][node_id][tetst_index].landline = value || "";
                                                newarray[mainindex][node_id][tetst_index].landline_without_country_code = value || "";
                                                setAttendeesDetail([...newarray]);
                                              }}
                                            />
                                            {/* Hidden inputs preserve element IDs used by "booking for myself" auto-fill */}
                                            <input type="hidden" id={mainindex + node_id + tetst_index + "landline_without_country_code"} />
                                            <input type="hidden" id={mainindex + node_id + tetst_index + "landline_country_code"} defaultValue="+61" />
                                          </Form.Group>

                                          <Form.Group
                                            controlId="CheckboxFaceToFace"
                                            className={
                                              getStream(cartItem.node.merchandise.id).toLowerCase() === "Face to Face"
                                                ? "form-group d-flex flex-wrap align-items-center dietary_req"
                                                : "d-none  form-group d-flex flex-wrap align-items-center dietary_req"
                                            }
                                          >
                                            <Form.Select
                                              className="form-control"
                                              name="dietary"
                                              onChange={(event) =>
                                                handleInputChange(node_id, tetst_index, event, mainindex, cartItem.node.merchandise.id)
                                              }
                                            >
                                              <option value="">Dietary requirement</option>
                                              <option value="VGT">Vegetarian</option>
                                              <option value="VGN">Vegan</option>
                                              <option value="GF">Gluten Free</option>
                                            </Form.Select>
                                          </Form.Group>
                                        </div>
                                      </Form>
                                    </Card.Text>
                                  );
                                })}

                                {/* ── T&C checkboxes + CTA — only inside the LAST cart item card ── */}
                                {mainindex === CartData.cart.lines.edges.length - 1 && (
                                  <>
                                    <div className="attendees_tc_box">
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          id="check_term"
                                          className={TermSelected_error ? "form-check-input form-error" : "form-check-input"}
                                          onChange={(e) => { setTermSelected(!TermSelected); if (TermSelected_error) setTermSelected_error(false); }}
                                        />
                                        <label title="" htmlFor="check_term" className="form-check-label">
                                          Accept <a onClick={(e) => { e.preventDefault(); e.stopPropagation(); set_tc_show(true); }}>terms and condition</a>
                                        </label>
                                      </div>
                                      {TermSelected_error && <span className="field-error-msg">Please accept the terms and conditions</span>}
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          id="check_privacy"
                                          className={PiravacySelected_error ? "form-check-input form-error" : "form-check-input"}
                                          onChange={(e) => { setPiravacySelected(!PiravacySelected); if (PiravacySelected_error) setPiravacySelected_error(false); }}
                                        />
                                        <label title="" htmlFor="check_privacy" className="form-check-label">
                                          Accept <a onClick={(e) => { e.preventDefault(); e.stopPropagation(); set_pp_show(true); }}>privacy policy</a>
                                        </label>
                                      </div>
                                      {PiravacySelected_error && <span className="field-error-msg">Please accept the privacy policy</span>}
                                    </div>

                                    {ErrorMessageText !== undefined ? <Alert variant="danger">{ErrorMessageText}</Alert> : ""}

                                    <div className="attendees_cta">
                                      {Is_intensive_download && !props.useLoggedIn ? (
                                        /* Login is compulsory for this program — show a Login button
                                           styled like Checkout (same btn-lg) instead of a text notice. */
                                        <Button type="button" className="btn-lg" onClick={() => props.ShowLoginPopup()}>
                                          Login here
                                        </Button>
                                      ) : IsThereAnyPastPrograme ? null : (
                                        <Button type="submit" className="btn-lg" onClick={SubmitAttendees}>
                                          Checkout
                                        </Button>
                                      )}
                                      <Link to={"/" + GAurl} className="btn-link">
                                        Continue shopping
                                      </Link>
                                    </div>
                                  </>
                                )}
                              </Accordion.Body>
                            </Card.Body>
                          </Card>
                        </Accordion.Item>
                      </Accordion>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div className="attendees_right_sticky">
              <div className="attendees_order_right_sidebar">
                {CartData.cart.lines.edges.length ? (
                  <>
                    <h3>Order</h3>
                    <div className="attendees_order_listing">
                      {CartData.cart.lines.edges.map((cartItem, mainindex) => {
                        const priceBYqyt = cartItem.node.merchandise.price.amount * cartItem.node.quantity;

                        return (
                          <div key={"de" + mainindex} className="attendees_order_items">
                            <h6 className="display-6">{cartItem.node.merchandise.product.title}</h6>
                            {isNotEmpty(getStream(cartItem.node.merchandise.id)) ? (
                              <small>(Attendance: {getStream(cartItem.node.merchandise.id)})</small>
                            ) : null}
                            <h6 className="display-6 attendees_order_price">${numberWithCommas(priceBYqyt)}</h6>
                          </div>
                        );
                      })}
                    </div>

                    <div className="attendees_order_item_total d-flex flex-wrap align-items-center justify-content-between">
                      <h6 className="display-6 text-secondary">Item Total</h6>
                      <h6 className="display-6 text-secondary">${numberWithCommas(CartData.cart.cost.subtotalAmount.amount)}</h6>
                    </div>

                    <div className="attendees_order_total_gst d-flex flex-wrap align-items-center justify-content-between">
                      <h3 className="text-white mb-0">
                        Total
                        <small className="display-6 text-white mb-0">(Including GST)</small>
                      </h3>
                      <h3 className="text-white mb-0">${numberWithCommas(CartData.cart.cost.totalAmount.amount)}</h3>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>

              <div className="need_help_block">
                <h6 className="display-6">
                  Need Help ?{" "}
                  <a href="mailto:registration@leocussen.edu.au" className="btn-link">
                    Get in touch
                  </a>
                  .
                </h6>
                <div className=" d-flex flex-wrap align-items-center justify-content-between">
                  <h3>
                    <CallPhoneIcon /> <a href="tel:1300 039 031">1300 039 031</a>
                  </h3>
                </div>
              </div>
              </div>
            </Col>
          </Row>
        </Container>
        <TermsCondition show={tc_show} hide={HideTCPopup} />
        <PrivacyPolicy show={pp_show} hide={HidePPPopup} />
      </div>
    );
  }
  return (
    <div className="attendees_page">
      <Container>
        <h3>Please visit Course page to purchase course</h3>
      </Container>
    </div>
  );
};
